import React from 'react';
import CloseIcon from '@mui/icons-material/Close';
import PropTypes from 'prop-types';
import profilePicture from '../../../Assets/Images/profile-picture-placeholder.svg';
import { ProfilePicture } from '../../Header/styles';
import Container from './styles';
import isAvatar from '../../../utils/isAvatar';

const Header = ({ informations, toggleModal }) => (
  <Container>
    <div>
      <ProfilePicture
        src={informations.discord ? isAvatar(informations) : profilePicture}
        alt="discord icon"
        onClick={() => toggleModal()}
      />
      <span>
        {informations.discord ? informations.discord.username : 'pseudo'}
      </span>
    </div>
    <CloseIcon
      onClick={() => toggleModal()}
      className="cursor-pointer defaultWhite"
    />
  </Container>
);

Header.propTypes = {
  informations: PropTypes.shape({
    discord: PropTypes.shape({
      avatar: PropTypes.string,
      discriminator: PropTypes.string.isRequired,
      id: PropTypes.string.isRequired,
      locale: PropTypes.string.isRequired,
      member: PropTypes.bool.isRequired,
      username: PropTypes.string.isRequired,
    }),
  }).isRequired,
  toggleModal: PropTypes.func.isRequired,
};

export default Header;
